import { Briefing } from "./types";

export const mockBriefing: Briefing = {
  address: {
    city: "São Paulo",
    state: "SP",
    country: "Brasil",
  },
  structure: {
    employees: [
      { name: "Alice", role: "Desenvolvedora" },
      { name: "Bob", role: "Designer" },
      { name: "Barbara", role: "Astronauta" },
    ],
    company_size: "medium",
    invoice_model: "Assinatura",
  },
  brand: {
    company_value: "Inovação e qualidade",
    company_differentiators: ["Foco no cliente", "Tecnologia de ponta"],
  },
  market_target: {
    public: "Pequenas e médias empresas",
    services: [
      { name: "Desenvolvimento Web" },
      { name: "Agiotagem" },
      { name: "Desenvolvimento de Apps Mobile" },
    ],
  },
  history_and_conquests: {
    history:
      "Fundada em 2010, com foco em oferecer soluções de software sob medida.",
    conquests: [
      { name: "Prêmio Melhor Startup", date: "2015-06-15" },
      { name: "Certificação ISO 9001", date: "2020-10-01" },
    ],
  },
};
